import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

export const getCountryListAPI = async () => {
  try {
    const response = await apiService.get(endpoints.getCountryList);
    return response.data;
  } catch (error) {
    console.error("Country API Error:", error);
    throw error;
  }
};

export const getStateListAPI = async (countryId) => {
  try {
    // Changed to use query parameter instead of path parameter
    const response = await apiService.get(endpoints.getStateList, { 
      country_id: countryId 
    });
    return response.data;
  } catch (error) {
    console.error("State API Error:", error);
    throw error;
  }
};

export const getCityListAPI = async (stateId) => {
  try {
    // Changed to use query parameter instead of path parameter
    const response = await apiService.get(endpoints.getCityList, { 
      state_id: stateId 
    });
    return response.data;
  } catch (error) {
    console.error("City API Error:", error);
    throw error;
  }
};